import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import TalentLayout from 'layout/TalentLayout';
import AuthGuard from 'utils/route-guard/AuthGuard';

const TalentView = Loadable(lazy(() => import('pages/dashboard')));
const Tasks = Loadable(lazy(() => import('pages/tasks')));

// ==============================|| TALENT ||============================== //

const TalentRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <TalentLayout />
    </AuthGuard>
  ),
  children: [
    { path: '/', element: <TalentView /> },
    { path: '/tasks', element: <Tasks mode="talent" /> }
  ]
};

export default TalentRoutes;
